import React from 'react';
import {
  Drawer, Box, IconButton, Typography
} from '@mui/material';
import { Close } from '@mui/icons-material';

const DynamicOffcanvas = ({
  open = false,
  title = "",
  children,
  onClose,
  width = '45%', // Default 45% for desktop
  actions = null,
  loading = false,
  hideHeader = false
}) => {
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      // 1. Bring the BACKDROP to the front
      BackdropProps={{
        sx: { 
          backgroundColor: { 
            xs: 'rgba(0,0,0,0.5)', 
            sm: 'rgba(0,0,0,0.5)', 
            md: 'rgba(0,0,0,0.3)',
            lg: 'rgba(0,0,0,0.3)',
            xl: 'rgba(0,0,0,0.3)',
          },
          // Forces backdrop above standard fixed headers (usually z-index 1200-1300)
          zIndex: 1399 
        }
      }}
      PaperProps={{
        // 2. Bring the DRAWER PAPER to the very front
        sx: { 
          // Forces drawer above the backdrop and any fixed headers
          zIndex: 1400, 
          
          // Mobile: 100%, Tablet: 100%, Desktop (Windows): 45% from right
          width: { 
            xs: '100%', 
            sm: '100%', 
            md: typeof width === 'number' ? `${width}px` : width,
            lg: typeof width === 'number' ? `${width}px` : width,
            xl: typeof width === 'number' ? `${width}px` : width,
          }, 
          height: '100%',          
          display: 'flex',         
          flexDirection: 'column', 
          overflow: 'hidden',
          
          // Add a subtle left border for visual separation on desktop
          borderLeft: { 
            xs: 'none', 
            sm: 'none', 
            md: '1px solid rgba(0,0,0,0.12)',
            lg: '1px solid rgba(0,0,0,0.12)',
            xl: '1px solid rgba(0,0,0,0.12)',
          },
          // Add slight shadow on desktop
          boxShadow: { 
            xs: 'none', 
            sm: 'none', 
            md: '-4px 0 20px rgba(0,0,0,0.1)',
            lg: '-4px 0 20px rgba(0,0,0,0.1)',
            xl: '-4px 0 20px rgba(0,0,0,0.1)',
          },
        }
      }}
    >
      {/* Header - Stays fixed at top */}
      {!hideHeader && (
        <Box 
          display="flex" 
          justifyContent="space-between" 
          alignItems="center" 
          sx={{ 
            p: { xs: 2, md: 3 }, 
            pb: 1, 
            flexShrink: 0,
            borderBottom: { 
              xs: 'none', 
              md: '1px solid rgba(0,0,0,0.08)',
            }
          }}
        >
          <Typography 
            variant="h6" 
            fontWeight={700}
            sx={{
              fontSize: { xs: '1.1rem', md: '1.25rem' }
            }}
          >
            {title}
          </Typography>
          <IconButton 
            onClick={onClose} 
            disabled={loading}
            sx={{
              '&:hover': {
                backgroundColor: 'rgba(0,0,0,0.05)',
                borderRadius: 2
              }
            }}
          >
            <Close />
          </IconButton>
        </Box>
      )}
      
      {/* Scrollable Content Area - Form fields go here */}
      <Box 
        sx={{ 
          flex: 1,              
          minHeight: 0,         
          overflowY: 'auto',    
          px: { xs: 2, md: 3 }, 
          pb: 2,
          pt: { xs: 1, md: 2 },
          scrollbarWidth: "thin",  
          '&::-webkit-scrollbar': { 
            width: '6px',
          },
          '&::-webkit-scrollbar-track': {
            backgroundColor: 'transparent',
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'rgba(0,0,0,0.2)',
            borderRadius: 3,
          },
          '&::-webkit-scrollbar-thumb:hover': {
            backgroundColor: 'rgba(0,0,0,0.3)',
          },
        }}
      >
        {children}
      </Box>
      
      {/* Sticky Footer / Actions - Stays fixed at bottom */}
      {actions && (
        <Box 
          sx={{ 
            p: { xs: 2, md: 3 },
            pt: 2,
            borderTop: '1px solid #e0e0e0',
            bgcolor: 'background.paper', 
            flexShrink: 0,               
            boxShadow: '0 -2px 10px rgba(0,0,0,0.05)' 
          }}
        >
          {actions}
        </Box>
      )}
    </Drawer>
  );
};

export default DynamicOffcanvas;